import Base from './Base';

class Events extends Base {
  async sendAnalyticsEvent(payload: { eventName: string }) {
    const response = await this.apiClient.post('/analytics/event', {
      ...payload,
      eventSource: 'web',
    });

    return response.data;
  }
}

export default Events;
